import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import API from "../Api/Api";
import { API_BASE_URL } from "../Functions/Constant";
import Home from "./Home";
// Expired Modal Component
const ExpiredModal = ({ show, handleClose, setShowEmailModal, email, resendMessage, setResendMessage, setTimerId, setShowSuccessModal, timerId, setShowExpiredModal }) => {
  const navigate = useNavigate();

  const handleResend = async () => {
    try {
      const payload = { email };
      const response = await API.post("/business/login", payload);
      setResendMessage("Link sent successfully!");
      // Clear existing timer and start a new 15-minute timer
      if (timerId) clearTimeout(timerId);
      const newTimer = setTimeout(() => {
        setShowSuccessModal(false);
        setShowExpiredModal(true);
      }, 15 * 60 * 1000); // 15 minutes
      setTimerId(newTimer);
      // Show SuccessModal and close ExpiredModal
      setShowSuccessModal(true);
      setShowExpiredModal(false);
    } catch (error) {
      console.error("API Error:", error);
      setResendMessage("Failed to resend. Please try again.");
    }
  };

  const handleCloseModal = () => {
    handleClose(); // Close expired modal
    if (timerId) clearTimeout(timerId); // Clear timer
    navigate("/"); // Navigate to home page
  };

  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      dialogClassName="custom-modal-dialog"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="pt-[12px] pb-[15px]">
        <p className="text-gray-600 text-center flex items-center justify-center p-[1px]">
          <img
            src="https://jobcritics.com/assets/img/biar/expird.webp"
            alt="Magic Link Expired"
            className="w-[150px] mr-2"
          />
        </p>
        <h6 className="font-semibold text-black text-center w-full mb-0 mt-[0px] pb-[5px]">
          Magic Link Expired
        </h6>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
          Your magic link has expired. Would you like us to resend it?
        </p>
        <div className="grid mt-[11px] w-full gap-3 justify-center">
          <button
            className="btn-explore-yellow text-c pd3 !w-[294px]"
            onClick={handleResend}
          >
            Resend Link
          </button>
          <p
            className="text-gray-700 hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px]"
            onClick={handleCloseModal}
          >
            Cancel
          </p>
        </div>
        {resendMessage && (
          <p className="text-center mt-2 text-sm text-green-500">
            {resendMessage}
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
};

// Success Modal Component
const SuccessModal = ({ show, handleClose, setShowEmailModal, email, timerId, setTimerId, resendMessage, setResendMessage, setShowExpiredModal }) => {
  const navigate = useNavigate();

  const handleClose2 = () => {
    handleClose(); // Close the success modal
    if (timerId) clearTimeout(timerId); // Clear the timer
    navigate("/"); // Navigate to home page
  };

  const handleResend = async () => {
    try {
      const payload = { email };
      const response = await API.post("/business/login", payload);
      setResendMessage("Link sent successfully!");
      // Clear existing timer and start a new 15-minute timer
      if (timerId) clearTimeout(timerId);
      const newTimer = setTimeout(() => {
        handleClose(); // Close SuccessModal
        setShowExpiredModal(true);
      }, 15 * 60 * 1000); // 15 minutes
      setTimerId(newTimer);
    } catch (error) {
      console.error("API Error:", error);
      setResendMessage("Failed to resend. Please try again.");
    }
  };

  const handleGoBack = () => {
    setShowEmailModal(true); // Reopen email modal
    handleClose(); // Close success modal
    if (timerId) clearTimeout(timerId); // Clear the timer
  };

  return (
    <Modal
      show={show}
      onHide={handleClose2}
      dialogClassName="custom-modal-dialog"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="pt-[12px] pb-[15px]">
        <p className="text-gray-600 text-center flex items-center justify-center p-[1px]">
          <img
            src="https://jobcritics.com/assets/img/biar/magiclink.webp"
            alt="Success!"
            className="w-[150px] mr-2"
          />
        </p>
        <h6 className="font-semibold text-black text-center w-full mb-0 mt-[0px] pb-[5px]">
          Success!
        </h6>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[0px]">
          We’ve sent a secure login link to{" "}
          <strong className="text-blue-600 hover:underline cursor-pointer">
            {email}
          </strong>.
        </p>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
          Click the link in your email to sign in.
        </p>
        <div className="mt-2 text-gray-600">
          <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[0px]">
            <strong>Didn’t get the email?</strong>
          </p>
          <ul className="list-none pl-0">
            <li className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
              Check your spam or promotions folder
            </li>
          </ul>
        </div>
        <div className="grid mt-[11px] w-full gap-3 justify-center">
          <button
            className="btn-explore-yellow text-c pd3 !w-[294px]"
            onClick={handleResend}
          >
            Resend Link
          </button>
          <p
            className="text-gray-700 hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px]"
            onClick={handleGoBack}
          >
            GO BACK
          </p>
        </div>
        {resendMessage && (
          <p className="text-center mt-2 text-sm text-green-500">
            {resendMessage}
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
};

// Email Input Modal Component
const EmailModal = ({
  show,
  handleClose,
  setShowSuccessModal,
  setSubmittedEmail,
  setTimerId,
  setShowExpiredModal,
  setResendMessage,
  timerId,
}) => {
  const navigate = useNavigate();
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const recaptchaRef = useRef();

  // useEffect(() => {
  //   console.log("reCAPTCHA script is assumed to be loaded via index.html");
  // }, []);

  const handleRecaptchaChange = (value) => {
    setIsRecaptchaVerified(!!value);
  };

  // List of disallowed personal email domains
  const personalEmailDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "protonmail.com",
    "zoho.com",
    "mail.com",
    "gmx.com",
    "yandex.com",
  ];

  const EmailSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email")
      .required("Email is required")
      .test(
        "is-work-email",
        "Please use a work email address",
        (value) => {
          if (!value) return false; // Skip if email is empty (handled by required)
          const domain = value.split("@")[1]?.toLowerCase();
          return !personalEmailDomains.includes(domain);
        }
      ),
    recaptcha: Yup.bool()
      .oneOf([true], "Please verify the reCAPTCHA")
      .required("reCAPTCHA is required"),
    termsAgreed: Yup.bool()
      .oneOf([true], "You must agree to the Terms of Use and Privacy Policy")
      .required("You must agree to the Terms of Use and Privacy Policy"),
  });

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        navigate("/"); // Navigate to home on modal close
        setIsRecaptchaVerified(false);
        recaptchaRef.current?.reset();
        if (timerId) clearTimeout(timerId); // Clear timer on close
      }}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal-dialog "
    >
      <Modal.Body className="pt-[18px] pb-[14px] ">
        <p className="text-gray-600 text-center flex items-center justify-center p-[1px]">
          <img
            src="https://jobcritics.com/assets/img/biar/emailnew.webp"
            alt="Sign in with Magic Link"
            className="w-[150px] mr-2"
          />
        </p>
        <h6 className="font-semibold text-black text-center w-full mb-0 mt-[4px] pb-[5px]">
          Sign in with Magic Link
        </h6>
        <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
          Enter your business email address and we’ll send you a secure login link.
        </p>

        <Formik
          initialValues={{ email: "", recaptcha: false, termsAgreed: false }}
          validationSchema={EmailSchema}
          onSubmit={async (values, { resetForm }) => {
            if (!isRecaptchaVerified) return;
            try {
              const payload = { email: values.email };
              const response = await API.post("/business/login", payload);
              setSubmittedEmail(values.email);
              setShowSuccessModal(true);
              // Start 15-minute timer
              const timer = setTimeout(() => {
                setShowSuccessModal(false);
                setShowExpiredModal(true);
              }, 15 * 60 * 1000); // 15 minutes
              setTimerId(timer);
              resetForm();
              handleClose();
            } catch (error) {
              console.error("API Error:", error);
              setResendMessage("Failed to send link. Please try again.");
            }
          }}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form>
              <div className="mb-1">
                <Field
                  name="email"
                  type="email"
                  placeholder="Your email address"
                  className="form-control fomc-cls"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger text-sm mt-0"
                />
              </div>
              <div className="mb-[0px] mt-[25px]">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey="6LeMeB0rAAAAANu99dAvFdegQ5rV6L-8plZSr4Fa"
                  onChange={(value) => {
                    handleRecaptchaChange(value);
                    setFieldValue("recaptcha", !!value);
                  }}
                  className="mt-4 flex justify-center "
                />
                  <ErrorMessage
                name="recaptcha"
                component="div"
                className="text-danger text-sm mt-0 text-center"
              />
              </div>
              <div className="mb-4">
                <p className="text-gray-600 text-[14px] leading-[1.6] mt-1 p-[12px]">
                  <Field
                    type="checkbox"
                    name="termsAgreed"
                    className="form-check-input mr-2"
                  />{" "}
                  By proceeding, you agree to our{" "}
                  <a href="/term_policy" className="yellow-class hover:underline hover:underline decoration-black">
                    Terms of Use
                  </a>{" "}
                  and confirm you have read our{" "}
                  <a href="/privacy" className="yellow-class hover:underline hover:underline decoration-black">
                    Privacy and Cookie Statement
                  </a>.
                </p>
                <ErrorMessage
                  name="termsAgreed"
                  component="div"
                  className="text-danger text-sm mt-1 text-center"
                />
              </div>
              <div className="grid mt-[16px] w-full gap-3 justify-center">
                <Button
                  className="btn-explore-yellow text-c pd3 !w-[294px]"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Send Magic Link
                </Button>
                <p
                  className="text-gray-700 hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px]"
                  onClick={() => {
                    handleClose(); // Close the modal
                    navigate("/"); // Navigate to home
                    setIsRecaptchaVerified(false);
                    recaptchaRef.current?.reset();
                    if (timerId) clearTimeout(timerId); // Clear timer
                  }}
                >
                  GO BACK
                </p>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

// Main BusinessLoginRegister Component
const BusinessLoginRegister = () => {
  const [showEmailModal, setShowEmailModal] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [resendMessage, setResendMessage] = useState("");

  return (
    <div>
       <Home />
      <EmailModal
        show={showEmailModal}
        handleClose={() => {
          setShowEmailModal(false);
          if (timerId) clearTimeout(timerId); // Clear timer on close
        }}
        setShowSuccessModal={setShowSuccessModal}
        setSubmittedEmail={setSubmittedEmail}
        setTimerId={setTimerId}
        setShowExpiredModal={setShowExpiredModal}
        setResendMessage={setResendMessage}
        timerId={timerId}
      />
      <SuccessModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        setShowEmailModal={setShowEmailModal}
        email={submittedEmail}
        timerId={timerId}
        setTimerId={setTimerId}
        resendMessage={resendMessage}
        setResendMessage={setResendMessage}
        setShowExpiredModal={setShowExpiredModal}
      />
      <ExpiredModal
        show={showExpiredModal}
        handleClose={() => setShowExpiredModal(false)}
        setShowEmailModal={setShowEmailModal}
        email={submittedEmail}
        resendMessage={resendMessage}
        setResendMessage={setResendMessage}
        setTimerId={setTimerId}
        setShowSuccessModal={setShowSuccessModal}
        timerId={timerId}
        setShowExpiredModal={setShowExpiredModal}
      />
    </div>
  );
};

export default BusinessLoginRegister;